var _path, _path2, _path3, _path4, _rect, _rect2, _path5, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8684 7H8C7.44772 7 7 7.44772 7 8V16C7 16.5523 7.44772 17 8 17H15.8684C16.4207 17 16.8684 16.5523 16.8684 16V8C16.8684 7.44772 16.4207 7 15.8684 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C7 7.44771 7.44772 7 8 7H16C16.5523 7 17 7.44772 17 8V8.66667H7V8Z",
    fill: "#8B95AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2334 10.8333C8.2334 10.5572 8.45726 10.3333 8.7334 10.3333H9.70708C9.98322 10.3333 10.2071 10.5572 10.2071 10.8333V11.8333C10.2071 12.1095 9.98322 12.3333 9.70708 12.3333H8.7334C8.45726 12.3333 8.2334 12.1095 8.2334 11.8333V10.8333Z",
    fill: "#8B95AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2334 13.8332C8.2334 13.5571 8.45726 13.3332 8.7334 13.3332H9.70708C9.98322 13.3332 10.2071 13.5571 10.2071 13.8332V14.8332C10.2071 15.1094 9.98322 15.3332 9.70708 15.3332H8.7334C8.45726 15.3332 8.2334 15.1094 8.2334 14.8332V13.8332Z",
    fill: "#8B95AB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9482,
    y: 13.3332,
    width: 1.97368,
    height: 2,
    rx: 0.5,
    fill: "#8B95AB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9482,
    y: 10.3333,
    width: 1.97368,
    height: 2,
    rx: 0.5,
    fill: "#8B95AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6601 10.8333C13.6601 10.5572 13.8839 10.3333 14.1601 10.3333H15.1338C15.4099 10.3333 15.6338 10.5572 15.6338 10.8333V11.8333C15.6338 12.1095 15.4099 12.3333 15.1338 12.3333H14.1601C13.8839 12.3333 13.6601 12.1095 13.6601 11.8333V10.8333Z",
    fill: "#8B95AB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.9f3b51de.svg";
export { ForwardRef as ReactComponent };